

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const REJECTMANAGEREVALUATION= createAsyncThunk(
  "rejectManagerEvaluation/rejectManagerEvaluation",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const rejectManagerEvaluationSlice = createSlice({
  name: "rejectManagerEvaluationSlice",
  initialState: {
    rejectManagerEvaluation: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfrejectManagerEvaluation: (state) => {
        state.rejectManagerEvaluation.loading = false
        state.rejectManagerEvaluation.error = false
        state.rejectManagerEvaluation.data = []
        state.rejectManagerEvaluation.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(REJECTMANAGEREVALUATION.fulfilled, (state, action) => {
      state.rejectManagerEvaluation = {
        ...state.rejectManagerEvaluation,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTMANAGEREVALUATION.pending, (state, action) => {
      state.rejectManagerEvaluation = {
        ...state.rejectManagerEvaluation,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTMANAGEREVALUATION.rejected, (state, action) => {
      state.rejectManagerEvaluation = {
        ...state.rejectManagerEvaluation,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const rejectManagerEvaluationAction = {
    REJECTMANAGEREVALUATION,
};

export { rejectManagerEvaluationAction };
export default rejectManagerEvaluationSlice.reducer;
export const {setInitialStateOfrejectManagerEvaluation} = rejectManagerEvaluationSlice.actions
